import React, { useState, useEffect } from "react";
import imgLeft from "../../Assets/Images/FAQ_SideImg.png";
import imgRight from "../../Assets/Images/Denting&Painting.png";

const BodyContent = ({ blogData }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (!blogData) return null;

  return (
    <div className="w-full px-4 md:px-10 py-4 grid gap-4">
      {loading ? (
        /* Skeleton Loader */
        <div className="animate-pulse w-full xl:w-[872px] grid gap-6">
          {/* Heading skeleton */}
          <div className="h-6 bg-gray-300 rounded w-5/6"></div>
          <div className="h-6 bg-gray-300 rounded w-2/3"></div>

          {/* Paragraph 1 skeleton */}
          <div className="space-y-3">
            <div className="h-4 bg-gray-300 rounded w-full"></div>
            <div className="h-4 bg-gray-300 rounded w-5/6"></div>
            <div className="h-4 bg-gray-300 rounded w-4/6"></div>
          </div>

          {/* Paragraph 2 skeleton */}
          <div className="space-y-3">
            <div className="h-4 bg-gray-300 rounded w-full"></div>
            <div className="h-4 bg-gray-300 rounded w-11/12"></div>
            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
            <div className="h-4 bg-gray-300 rounded w-2/3"></div>
          </div>

          {/* Images skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4">
            <div className="h-[400px] bg-gray-300 rounded-lg w-full"></div>
            <div className="h-[400px] bg-gray-300 rounded-lg w-full"></div>
          </div>

          {/* Paragraph 3 skeleton */}
          <div className="space-y-3">
            <div className="h-4 bg-gray-300 rounded w-full"></div>
            <div className="h-4 bg-gray-300 rounded w-10/12"></div>
            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
          </div>
        </div>
      ) : (
        <>
          <div>
            <h3 className="text-gray-900 font-medium text-[20px] w-full ">
              {blogData.title}
            </h3>
          </div>

          <div className="py-2">
            <p className="text-gray-500 text-lg w-full ">{blogData.content}</p>
          </div>

          <div className="w-full  grid grid-cols-1 md:grid-cols-2 gap-4 py-4">
            <div className="grid">
              <img
                src={blogData.image}
                alt={blogData.title}
                className="h-[400px] w-full object-cover rounded-lg"
              />
            </div>
            <div className="grid">
              <img
                src={imgRight}
                alt="Related content"
                className="h-[400px] w-full object-cover rounded-lg"
              />
            </div>
          </div>

          {/* <div>
            <p className="text-gray-500 text-lg w-full ">
              This comprehensive guide explores the key aspects of{" "}
              {blogData.title.toLowerCase()}, providing valuable insights and
              practical tips. By following the recommendations outlined in this
              blog, you can ensure optimal results and long-term success. For
              more detailed information and professional assistance, don't
              hesitate to reach out to our expert team.
            </p>
          </div> */}
        </>
      )}
    </div>
  );
};

export default BodyContent;
